import Service from '@/service/index.js';

export default {
  components: {
  },
  data() {
    return {
      detail: {},
      id: '',
      count: true
    };
  },
  created() {
    document.body.scrollTop =0;
	  document.documentElement.scrollTop = 0;
    if (this.$route.query && this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    this.getNewsDetail();
  },
  methods: {
    getNewsDetail() {
      Service.getNewsDetail({id: this.id, count: this.count}).then(res => {
        if (res && res.code === '0') {
          this.detail = res.data;
        }
      });
    }
  }
};
